import { Fragment } from "react";
import { cn } from "../../utilities/tailwind";

type CountdownUnit = {
  label: string;
  value: number | string;
};

export type CountdownProperties = {
  className?: string | undefined;
  separatorClassName?: string | undefined;
  unitBaseClassName?: string | undefined;
  unitLabelClassName?: string | undefined;
  unitValueClassName?: string | undefined;
  units: CountdownUnit[];
};
export const Countdown = ({
  className = "",
  unitBaseClassName = "",
  unitValueClassName = "",
  unitLabelClassName = "",
  separatorClassName = "",
  units,
  ...properties
}: CountdownProperties) => {
  const twClassName = cn(
    "flex w-fit items-center text-primary-variant antialiased",
    className,
  );

  const twUnitBase = cn(
    "rounded-lg bg-surface-container px-2 pt-1 text-center",
    unitBaseClassName,
  );
  const twUnitValue = cn(
    "text-m-heading leading-6 font-bold",
    unitValueClassName,
  );
  const twUnitLabel = cn("-mt-1 text-legal leading-4", unitLabelClassName);
  const twSeparator = cn("mx-1 text-editorial! md:mx-3", separatorClassName);

  return (
    <div className={twClassName} {...properties}>
      {units.map((unit, index) => (
        <Fragment key={unit.label}>
          <span className={twUnitBase}>
            <div className={twUnitValue}>{unit.value} </div>
            <div className={twUnitLabel}>{unit.label}</div>
          </span>

          {index !== units.length - 1 && (
            <span className={twSeparator}>&#58;</span>
          )}
        </Fragment>
      ))}
    </div>
  );
};

Countdown.displayName = "Countdown";

export { getUnitsOfTime, useCountdown } from "./use-countdown";
